module.exports = __webpack_public_path__ + "img/image6.459f3a68.png";